import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonBadge,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonGrid,
  IonText,
} from '@ionic/react';
import { connect } from 'react-redux';
import { home, heart, chatbox } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import CommentModal from '../components/post/CommentModal';
import PostComment from '../components/post/PostComment';
import { getPost, addLike, removeLike, addComment, deletePost } from '../actions/post';
import PropTypes from 'prop-types';
import { formatDistanceToNow } from 'date-fns';
import 'react-quill/dist/quill.snow.css';
import { toast } from '../helpers/toast';
import './styles/Post.scss';

const Post = ({
  getPost,
  addLike,
  removeLike,
  addComment,
  deletePost,
  auth: { user },
  post: { post, loading },
  match,
}) => {
  useEffect(() => {
    getPost(match.params.id);
    // eslint-disable-next-line
  }, [getPost, addLike, removeLike]);

  const [showModal, setShowModal] = useState(false);

  function handleOpenModal() {
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
  }
  function handleAddComment(commentText) {
    const newComment = {
      text: commentText,
    };
    addComment(post && post._id, newComment);
    setShowModal(false);
    toast('Commented successfully');
  }
  function handleLike() {
    addLike(post && post._id);
    toast('You have liked the post');
  }
  function handleUnlike() {
    removeLike(post && post._id);
    toast('You have unliked the post');
  }
  function handleDelete() {
    deletePost(post && post._id);
    toast('Post deleted successfully');
  }

  return (
    <IonContent id='post'>
      <CommentModal
        isOpen={showModal}
        title='New Comment'
        sendAction={handleAddComment}
        closeAction={handleCloseModal}
      />
      <IonHeader>
        <IonToolbar color='secondary' style={{ padding: '0 5px' }}>
          <IonButtons slot='start'>
            <IonButton href='/dash'>
              <IonIcon slot='icon-only' icon={home} size='small' />
            </IonButton>
          </IonButtons>
          {Boolean((post && post.user) === (user && user._id)) && (
            <>
              <IonButton size='small' color='tertiary' slot='end' href={'/post/edit/' + (post && post._id)}>
                Edit
              </IonButton>
              <IonButton size='small' color='danger' slot='end' href='/dash' onClick={handleDelete}>
                Delete
              </IonButton>
            </>
          )}
          <IonTitle>
            <h5 className='title'>{post && post.title}</h5>
          </IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonCard>
        <IonCardHeader>
          <IonCardSubtitle>{post && post.authorName}</IonCardSubtitle>
          <IonCardTitle>{post && post.title}</IonCardTitle>
          <IonCardSubtitle>
            <IonBadge style={{ marginRight: '5px' }} color='secondary'>
              {post && post.topic}
            </IonBadge>
            {post && post.tags.map((tag) => <IonBadge style={{ marginRight: '5px' }}>{tag.slice(0, 50)}</IonBadge>)}
          </IonCardSubtitle>
        </IonCardHeader>

        <IonCardContent className='desc'>{post && post.desc}</IonCardContent>

        <IonCardContent className='content'>
          <div dangerouslySetInnerHTML={{ __html: post && post.content }} />
        </IonCardContent>

        <IonCardContent>
          <IonGrid>
            <IonRow>
              <IonCol style={{ textAlign: 'left' }}>
                <IonIcon
                  icon={heart}
                  style={{
                    verticalAlign: 'middle',
                    marginRight: '6px',
                  }}
                  color='danger'
                />{' '}
                <IonText
                  style={{
                    verticalAlign: 'middle',
                  }}
                  color='danger'
                >
                  {post && post.noOflikes} {post && post.noOflikes === 1 ? ' like' : ' likes'}
                </IonText>
                <br />
                <IonIcon
                  icon={chatbox}
                  style={{
                    verticalAlign: 'middle',
                    marginRight: '6px',
                  }}
                  color='dark'
                />{' '}
                <IonText
                  style={{
                    verticalAlign: 'middle',
                  }}
                  color='dark'
                >
                  {post && post.comments.length} {post && post.comments.length === 1 ? ' comment' : ' comments'}
                </IonText>
              </IonCol>
              <IonCol style={{ textAlign: 'right' }}>
                <em>posted {post && formatDistanceToNow(new Date(post.postedWhen))} ago</em>
                <br />
                <em>modified {post && formatDistanceToNow(new Date(post.lastModified))} ago</em>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCardContent>
      </IonCard>
      <div className='ion-text-center'>
        {post && post.likes.some((like) => like['user'] === user._id) ? (
          <IonButton onClick={handleUnlike} size='small'>
            Unlike
          </IonButton>
        ) : (
          <IonButton onClick={handleLike} size='small'>
            Like
          </IonButton>
        )}
        <IonButton onClick={() => handleOpenModal()} size='small'>
          Comment
        </IonButton>
      </div>
      {post && post.comments.length > 0 ? (
        post.comments.map((comment) => (
          <div className='ion-margin'>
            <PostComment key={comment._id} comment={comment} user={user._id} post={post._id} />
          </div>
        ))
      ) : (
        <div style={{ padding: '48px' }}></div>
      )}
    </IonContent>
  );
};
Post.propType = {
  getPost: PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  auth: PropTypes.func.isRequired,
  addLike: PropTypes.func.isRequired,
  removeLike: PropTypes.func.isRequired,
  addComment: PropTypes.func.isRequired,
  deletePost: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.register,
  post: state.post,
});
export default connect(mapStateToProps, { getPost, addLike, removeLike, addComment, deletePost })(Post);
